// HACK: this is a hacky file to handle the FE GQL query that's happening in the request detail page
// while keeping the business logic for agreements in one place

// NOTE: This should be imported in the FE so be careful of dependencies!

interface RequestInput {
  agreement_term: {
    agreementId: string
    name: string
  } | null
  sourceRenewal: {
    sourceAgreementTerm: {
      agreementId: string
      name: string
    } | null
  } | null
}

export const getAgreementIdForRequest = (request: RequestInput): { id: string; name: string } | null => {
  if (request.agreement_term?.agreementId) {
    return {
      id: request.agreement_term.agreementId,
      name: request.agreement_term.name,
    }
  }
  if (request.sourceRenewal?.sourceAgreementTerm?.agreementId) {
    return {
      id: request.sourceRenewal.sourceAgreementTerm.agreementId,
      name: request.sourceRenewal.sourceAgreementTerm.name,
    }
  }
  return null
}
